import { render, staticRenderFns } from "./AulaModal.vue?vue&type=template&id=60451e94&scoped=true"
import script from "./AulaModal.vue?vue&type=script&lang=js"
export * from "./AulaModal.vue?vue&type=script&lang=js"
import style0 from "./AulaModal.vue?vue&type=style&index=0&id=60451e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60451e94",
  null
  
)

export default component.exports